import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import okReservaLogo from '../assets/okreserva-logo.png';
import { Button } from '../components/ui/button';
import { cn } from '../lib/utils';
import {
  CalendarDays, Map, Users, PartyPopper, Mic, Building2, TrendingDown,
  Cake, BarChart3, Clock, Code2, Megaphone, ShieldCheck, Globe, Zap,
  ChevronDown, ArrowRight, Check, Sparkles, Sun, Moon, Play, QrCode,
  Gift, Star, MessageCircle, Wallet, UserCircle, Trophy, Smartphone,
  Heart, CreditCard
} from 'lucide-react';

// ===== SVG ILLUSTRATIONS for new features =====

function IllustrationPortal({ isDark }) {
  const bg  = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const txt  = isDark ? '#e2e8f0' : '#1e293b';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="110" y="20" width="140" height="220" rx="16" fill={card} stroke="#f97316" strokeWidth="1.5"/>
      <rect x="118" y="40" width="124" height="60" rx="10" fill="#f97316"/>
      <circle cx="158" cy="62" r="16" fill="white" fillOpacity="0.25"/>
      <text x="154" y="68" fontSize="18" fill="white" fontFamily="system-ui">👤</text>
      <text x="185" y="58" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui">Hola, María</text>
      <text x="185" y="70" fontSize="7" fill="white" fillOpacity="0.8" fontFamily="system-ui">OUser · @maria</text>
      <rect x="118" y="112" width="124" height="44" rx="8" fill={isDark ? '#1e293b' : '#f8fafc'}/>
      <rect x="126" y="118" width="60" height="6" rx="3" fill="#f97316"/>
      <rect x="126" y="129" width="100" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="126" y="137" width="80" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="118" y="164" width="58" height="36" rx="8" fill="#f97316"/>
      <text x="135" y="176" fontSize="6" fill="white" fontWeight="700" fontFamily="system-ui">🏆</text>
      <text x="127" y="188" fontSize="6" fill="white" fontWeight="600" fontFamily="system-ui">500 pts</text>
      <rect x="184" y="164" width="58" height="36" rx="8" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="190" y="176" width="32" height="4" rx="2" fill={isDark ? '#64748b' : '#94a3b8'}/>
      <rect x="190" y="185" width="24" height="4" rx="2" fill={isDark ? '#64748b' : '#94a3b8'}/>
      <rect x="20" y="80" width="72" height="44" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="28" y="90" width="40" height="4" rx="2" fill="#f97316"/>
      <rect x="28" y="99" width="56" height="3" rx="1.5" fill={isDark ? '#475569' : '#cbd5e1'}/>
      <rect x="28" y="107" width="40" height="3" rx="1.5" fill={isDark ? '#475569' : '#cbd5e1'}/>
      <rect x="268" y="80" width="72" height="44" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="276" y="90" width="40" height="4" rx="2" fill="#10b981"/>
      <rect x="276" y="99" width="56" height="3" rx="1.5" fill={isDark ? '#475569' : '#cbd5e1'}/>
      <rect x="276" y="107" width="40" height="3" rx="1.5" fill={isDark ? '#475569' : '#cbd5e1'}/>
    </svg>
  );
}

function IllustrationLoyalty({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="30" width="148" height="90" rx="14" fill="linear-gradient(135deg,#cd7f32,#b8730a)"/>
      <defs>
        <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#cd7f32"/>
          <stop offset="100%" stopColor="#a0522d"/>
        </linearGradient>
        <linearGradient id="g2" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#94a3b8"/>
          <stop offset="100%" stopColor="#475569"/>
        </linearGradient>
        <linearGradient id="g3" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f59e0b"/>
          <stop offset="100%" stopColor="#d97706"/>
        </linearGradient>
        <linearGradient id="g4" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#67e8f9"/>
          <stop offset="100%" stopColor="#0891b2"/>
        </linearGradient>
      </defs>
      <rect x="20" y="30" width="148" height="90" rx="14" fill="url(#g1)"/>
      <text x="36" y="58" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">🥉 BRONCE</text>
      <text x="36" y="76" fontSize="22" fill="white" fontWeight="900" fontFamily="system-ui">320</text>
      <text x="36" y="90" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">puntos acumulados</text>
      <rect x="36" y="100" width="108" height="6" rx="3" fill="rgba(255,255,255,0.3)"/>
      <rect x="36" y="100" width="45" height="6" rx="3" fill="white"/>
      <rect x="192" y="30" width="148" height="90" rx="14" fill="url(#g2)"/>
      <text x="208" y="58" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">🥈 PLATA</text>
      <text x="208" y="76" fontSize="22" fill="white" fontWeight="900" fontFamily="system-ui">750</text>
      <text x="208" y="90" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">puntos acumulados</text>
      <rect x="208" y="100" width="108" height="6" rx="3" fill="rgba(255,255,255,0.3)"/>
      <rect x="208" y="100" width="81" height="6" rx="3" fill="white"/>
      <rect x="20" y="138" width="148" height="90" rx="14" fill="url(#g3)"/>
      <text x="36" y="166" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">🥇 ORO</text>
      <text x="36" y="184" fontSize="22" fill="white" fontWeight="900" fontFamily="system-ui">1,820</text>
      <text x="36" y="198" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">puntos acumulados</text>
      <rect x="36" y="208" width="108" height="6" rx="3" fill="rgba(255,255,255,0.3)"/>
      <rect x="36" y="208" width="90" height="6" rx="3" fill="white"/>
      <rect x="192" y="138" width="148" height="90" rx="14" fill="url(#g4)"/>
      <text x="208" y="166" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">💎 DIAMANTE</text>
      <text x="208" y="184" fontSize="22" fill="white" fontWeight="900" fontFamily="system-ui">6,400</text>
      <text x="208" y="198" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">puntos acumulados</text>
      <rect x="208" y="208" width="108" height="6" rx="3" fill="rgba(255,255,255,0.3)"/>
      <rect x="208" y="208" width="108" height="6" rx="3" fill="white"/>
    </svg>
  );
}

function IllustrationGiftCards({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="30" y="60" width="200" height="130" rx="16" fill="#f97316"/>
      <circle cx="130" cy="30" r="28" fill="#fb923c" fillOpacity="0.4"/>
      <circle cx="30" cy="160" r="40" fill="#fb923c" fillOpacity="0.2"/>
      <rect x="46" y="78" width="80" height="6" rx="3" fill="rgba(255,255,255,0.4)"/>
      <text x="46" y="118" fontSize="28" fill="white" fontWeight="900" fontFamily="system-ui">$500</text>
      <text x="46" y="136" fontSize="9" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">Gift Card Digital</text>
      <text x="46" y="168" fontSize="8" fill="rgba(255,255,255,0.6)" fontFamily="system-ui" letterSpacing="3">•••• •••• •••• 4821</text>
      <rect x="180" y="50" width="150" height="96" rx="14" fill={card} stroke="#f97316" strokeWidth="1.5"/>
      <rect x="192" y="62" width="50" height="6" rx="3" fill="#f97316"/>
      <rect x="192" y="74" width="80" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="192" y="84" width="60" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="192" y="100" width="120" height="28" rx="8" fill="#f97316"/>
      <text x="228" y="119" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Enviar por WhatsApp</text>
      <rect x="180" y="158" width="150" height="72" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="192" y="170" width="40" height="4" rx="2" fill="#10b981"/>
      <rect x="192" y="180" width="126" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="192" y="190" width="100" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="192" y="206" width="126" height="16" rx="8" fill={isDark ? '#1e293b' : '#f1f5f9'}/>
      <rect x="196" y="210" width="60" height="4" rx="2" fill={isDark ? '#475569' : '#94a3b8'}/>
    </svg>
  );
}

function IllustrationNPS({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const bar = isDark ? '#1e293b' : '#f1f5f9';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="220" rx="16" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="40" y="50" fontSize="13" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">¿Cómo fue tu experiencia?</text>
      <text x="40" y="66" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Restaurante La Hacienda · 10 Apr 2026</text>
      <text x="40" y="95" fontSize="26" fontFamily="system-ui">⭐⭐⭐⭐☆</text>
      <rect x="40" y="112" width="280" height="18" rx="6" fill={bar}/>
      <rect x="40" y="112" width="230" height="18" rx="6" fill="#f97316"/>
      <text x="286" y="125" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">82%</text>
      <rect x="40" y="136" width="280" height="18" rx="6" fill={bar}/>
      <rect x="40" y="136" width="190" height="18" rx="6" fill="#fb923c"/>
      <text x="246" y="149" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">68%</text>
      <rect x="40" y="160" width="280" height="18" rx="6" fill={bar}/>
      <rect x="40" y="160" width="140" height="18" rx="6" fill="#fbbf24"/>
      <text x="196" y="173" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">50%</text>
      <text x="40" y="106" fontSize="7" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">Comida</text>
      <text x="40" y="130" fontSize="7" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">Servicio</text>
      <text x="40" y="154" fontSize="7" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">Ambiente</text>
      <rect x="40" y="190" width="134" height="34" rx="8" fill={bar}/>
      <rect x="184" y="190" width="136" height="34" rx="8" fill="#f97316"/>
      <text x="88" y="212" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontWeight="600" fontFamily="system-ui" textAnchor="middle">Más tarde</text>
      <text x="252" y="212" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Enviar encuesta →</text>
    </svg>
  );
}

function IllustrationWhatsApp({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="220" height="220" rx="16" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="20" y="20" width="220" height="44" rx="16" fill="#25d366"/>
      <circle cx="50" cy="42" r="12" fill="white" fillOpacity="0.3"/>
      <text x="47" y="47" fontSize="11" fontFamily="system-ui" fill="white">👤</text>
      <text x="70" y="38" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui">OkReserva Bot</text>
      <text x="70" y="52" fontSize="7" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">● en línea</text>
      <rect x="36" y="76" width="148" height="40" rx="10" fill="#dcf8c6"/>
      <text x="46" y="92" fontSize="8" fill="#1e293b" fontFamily="system-ui">✅ Tu reserva está confirmada</text>
      <text x="46" y="105" fontSize="7" fill="#4b5563" fontFamily="system-ui">El Sábado 12 Abr · 8:00 PM · 4 pers.</text>
      <rect x="36" y="126" width="170" height="40" rx="10" fill="#dcf8c6"/>
      <text x="46" y="140" fontSize="8" fill="#1e293b" fontFamily="system-ui">🎂 ¡Feliz cumpleaños, María!</text>
      <text x="46" y="153" fontSize="7" fill="#4b5563" fontFamily="system-ui">Tenemos un regalo especial para ti 🎁</text>
      <rect x="36" y="176" width="156" height="40" rx="10" fill="#dcf8c6"/>
      <text x="46" y="190" fontSize="8" fill="#1e293b" fontFamily="system-ui">⭐ ¿Cómo estuvo tu visita?</text>
      <text x="46" y="203" fontSize="7" fill="#4b5563" fontFamily="system-ui">Toca para dejar tu opinión</text>
      <rect x="256" y="40" width="84" height="180" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="264" y="52" width="68" height="8" rx="4" fill="#f97316"/>
      <rect x="264" y="66" width="44" height="6" rx="3" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="264" y="88" width="68" height="8" rx="4" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="264" y="102" width="44" height="6" rx="3" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="264" y="124" width="68" height="8" rx="4" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="264" y="138" width="44" height="6" rx="3" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="264" y="162" width="68" height="28" rx="8" fill="#25d366"/>
      <text x="298" y="180" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Activar</text>
    </svg>
  );
}

function IllustrationBookingPage({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const inp = isDark ? '#1e293b' : '#f8fafc';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="220" rx="16" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="20" y="20" width="320" height="48" rx="16" fill="#f97316"/>
      <rect x="20" y="48" width="320" height="20" fill="#f97316"/>
      <text x="40" y="40" fontSize="12" fill="white" fontWeight="800" fontFamily="system-ui">Restaurante La Hacienda</text>
      <text x="40" y="56" fontSize="8" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">📍 Monterrey · Reserva en línea</text>
      <text x="40" y="90" fontSize="10" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="600" fontFamily="system-ui">Hacer una reservación</text>
      <rect x="40" y="100" width="130" height="26" rx="8" fill={inp} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="52" y="117" fontSize="8" fill={isDark ? '#94a3b8' : '#94a3b8'} fontFamily="system-ui">📅 Sábado 12 Abr 2026</text>
      <rect x="180" y="100" width="120" height="26" rx="8" fill={inp} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="192" y="117" fontSize="8" fill={isDark ? '#94a3b8' : '#94a3b8'} fontFamily="system-ui">🕐 8:00 PM</text>
      <rect x="40" y="134" width="130" height="26" rx="8" fill={inp} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="52" y="151" fontSize="8" fill={isDark ? '#94a3b8' : '#94a3b8'} fontFamily="system-ui">👥 2 personas</text>
      <rect x="180" y="134" width="120" height="26" rx="8" fill={inp} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="192" y="151" fontSize="8" fill={isDark ? '#94a3b8' : '#94a3b8'} fontFamily="system-ui">🍽 Interior</text>
      <rect x="40" y="168" width="260" height="26" rx="8" fill={inp} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="52" y="185" fontSize="8" fill={isDark ? '#94a3b8' : '#94a3b8'} fontFamily="system-ui">📝 Notas especiales (opcional)</text>
      <rect x="40" y="204" width="260" height="26" rx="8" fill="#f97316"/>
      <text x="170" y="221" fontSize="10" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Confirmar Reservación →</text>
    </svg>
  );
}

function IllustrationDeposits({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="40" y="20" width="280" height="110" rx="16" fill="#f97316"/>
      <circle cx="300" cy="20" r="60" fill="rgba(255,255,255,0.08)"/>
      <circle cx="40" cy="130" r="50" fill="rgba(255,255,255,0.08)"/>
      <text x="60" y="50" fontSize="10" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">DEPÓSITO REQUERIDO</text>
      <text x="60" y="80" fontSize="30" fill="white" fontWeight="900" fontFamily="system-ui">$250</text>
      <text x="60" y="98" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">Reserva del Sábado 12 Abr · 8:00 PM</text>
      <text x="60" y="116" fontSize="8" fill="rgba(255,255,255,0.6)" fontFamily="system-ui">Se descuenta del total de tu cuenta</text>
      <rect x="40" y="146" width="134" height="90" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="54" y="160" width="40" height="4" rx="2" fill="#f97316"/>
      <rect x="54" y="170" width="100" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="54" y="180" width="80" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="54" y="196" width="106" height="28" rx="8" fill="#f97316"/>
      <text x="107" y="214" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Pagar con Tarjeta</text>
      <rect x="186" y="146" width="134" height="90" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="200" y="160" width="40" height="4" rx="2" fill="#10b981"/>
      <rect x="200" y="170" width="100" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <rect x="200" y="180" width="80" height="4" rx="2" fill={isDark ? '#334155' : '#e2e8f0'}/>
      <text x="248" y="205" fontSize="20" textAnchor="middle" fontFamily="system-ui">✅</text>
      <text x="248" y="222" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">Pago exitoso</text>
    </svg>
  );
}

function IllustrationAllergens({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const allergens = [
    { emoji: '🥜', label: 'Cacahuates', color: '#ef4444' },
    { emoji: '🌾', label: 'Gluten', color: '#f97316' },
    { emoji: '🥛', label: 'Lácteos', color: '#3b82f6' },
    { emoji: '🥚', label: 'Huevo', color: '#eab308' },
    { emoji: '🐟', label: 'Pescado', color: '#8b5cf6' },
    { emoji: '🦐', label: 'Mariscos', color: '#ec4899' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <text x="40" y="46" fontSize="13" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">Gestión de Alérgenos</text>
      <text x="40" y="62" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Perfil de María García · 4 alérgenos detectados</text>
      {allergens.map((a, i) => {
        const col = i % 3;
        const row = Math.floor(i / 3);
        const x = 40 + col * 100;
        const y = 78 + row * 70;
        return (
          <g key={i}>
            <rect x={x} y={y} width="84" height="54" rx="10" fill={card} stroke={a.color} strokeWidth="1.5"/>
            <text x={x + 18} y={y + 26} fontSize="18" fontFamily="system-ui">{a.emoji}</text>
            <text x={x + 44} y={y + 22} fontSize="8" fill={a.color} fontWeight="700" fontFamily="system-ui">{a.label}</text>
            <rect x={x + 44} y={y + 30} width="28" height="10" rx="5" fill={i < 4 ? a.color : isDark ? '#334155' : '#e2e8f0'}/>
            <text x={x + 58} y={y + 39} fontSize="7" fill={i < 4 ? 'white' : isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui" textAnchor="middle">{i < 4 ? 'Activo' : 'Off'}</text>
          </g>
        );
      })}
      <rect x="40" y="218" width="280" height="28" rx="8" fill="#f97316"/>
      <text x="180" y="236" fontSize="10" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Guardar perfil · Alertar al equipo</text>
    </svg>
  );
}

function IllustrationDigitalBook({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const rows = [
    { time: '13:00', name: 'García · 4p', color: '#10b981', status: 'Confirmada' },
    { time: '14:00', name: 'López · 2p',  color: '#f97316', status: 'Pendiente' },
    { time: '15:30', name: 'Martínez · 6p', color: '#3b82f6', status: 'Confirmada' },
    { time: '20:00', name: 'Rodríguez · 8p', color: '#8b5cf6', status: 'VIP' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="32" rx="8" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="41" fontSize="10" fill={isDark ? '#f97316' : '#f97316'} fontWeight="800" fontFamily="system-ui">📅 Libro Digital · Hoy Sábado</text>
      <rect x="20" y="22" width="8" height="8" rx="2" fill="#10b981" x="312" y="28"/>
      {rows.map((row, i) => (
        <g key={i}>
          <rect x="20" y={65 + i * 46} width="320" height="38" rx="8" fill={card} stroke={isDark ? '#1e293b' : '#f1f5f9'} strokeWidth="1"/>
          <rect x="20" y={65 + i * 46} width="4" height="38" rx="2" fill={row.color}/>
          <text x="36" y={79 + i * 46} fontSize="10" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" fontWeight="600">{row.time}</text>
          <text x="84" y={79 + i * 46} fontSize="10" fill={isDark ? '#f1f5f9' : '#1e293b'} fontFamily="system-ui" fontWeight="700">{row.name}</text>
          <rect x="250" y={68 + i * 46} width="76" height="18" rx="9" fill={row.color} fillOpacity="0.15"/>
          <text x="288" y={81 + i * 46} fontSize="8" fill={row.color} fontFamily="system-ui" fontWeight="700" textAnchor="middle">{row.status}</text>
          <text x="36" y={96 + i * 46} fontSize="8" fill={isDark ? '#475569' : '#94a3b8'} fontFamily="system-ui">Mesa interior · Zona A</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationFloorPlan({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const wall = isDark ? '#334155' : '#e2e8f0';
  const tables = [
    { x: 50,  y: 60,  w: 50, h: 36, label: 'T1', color: '#10b981', pers: '4p' },
    { x: 130, y: 60,  w: 50, h: 36, label: 'T2', color: '#f97316', pers: '2p' },
    { x: 210, y: 60,  w: 60, h: 36, label: 'T3', color: '#10b981', pers: '6p' },
    { x: 50,  y: 130, w: 80, h: 36, label: 'T4 VIP', color: '#8b5cf6', pers: '8p' },
    { x: 160, y: 130, w: 50, h: 36, label: 'T5', color: '#f97316', pers: '4p' },
    { x: 240, y: 130, w: 50, h: 36, label: 'T6', color: '#6b7280', pers: '4p' },
    { x: 50,  y: 200, w: 50, h: 36, label: 'T7', color: '#10b981', pers: '2p' },
    { x: 130, y: 200, w: 80, h: 36, label: 'T8 Terraza', color: '#3b82f6', pers: '6p' },
    { x: 240, y: 200, w: 50, h: 36, label: 'T9', color: '#10b981', pers: '4p' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="30" y="30" width="300" height="210" rx="10" fill="none" stroke={wall} strokeWidth="2"/>
      <text x="36" y="48" fontSize="9" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">🏠 Plano de Sala — OkReserva</text>
      {tables.map((t, i) => (
        <g key={i}>
          <rect x={t.x} y={t.y} width={t.w} height={t.h} rx="6" fill={t.color} fillOpacity="0.15" stroke={t.color} strokeWidth="1.5"/>
          <text x={t.x + t.w/2} y={t.y + 14} fontSize="8" fill={t.color} fontWeight="700" fontFamily="system-ui" textAnchor="middle">{t.label}</text>
          <text x={t.x + t.w/2} y={t.y + 26} fontSize="7" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">{t.pers}</text>
        </g>
      ))}
      <rect x="280" y="36" width="44" height="10" rx="5" fill="#10b981" fillOpacity="0.15"/>
      <text x="302" y="44" fontSize="6.5" fill="#10b981" fontFamily="system-ui" textAnchor="middle">● Libre</text>
    </svg>
  );
}

function IllustrationCRM({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="88" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <circle cx="58" cy="64" r="22" fill="#f97316" fillOpacity="0.15"/>
      <text x="50" y="70" fontSize="20" fontFamily="system-ui">👩</text>
      <text x="90" y="50" fontSize="13" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="800" fontFamily="system-ui">María García</text>
      <text x="90" y="65" fontSize="8" fill="#f97316" fontFamily="system-ui">⭐ Cliente VIP · 47 visitas</text>
      <text x="90" y="80" fontSize="8" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">🎂 Cumpleaños: 15 Mayo · 🌾 Gluten</text>
      <rect x="90" y="86" width="60" height="14" rx="7" fill="#10b981" fillOpacity="0.15"/>
      <text x="120" y="96" fontSize="7" fill="#10b981" fontFamily="system-ui" fontWeight="700" textAnchor="middle">1,820 pts 🏆</text>
      <rect x="160" y="86" width="60" height="14" rx="7" fill="#f97316" fillOpacity="0.15"/>
      <text x="190" y="96" fontSize="7" fill="#f97316" fontFamily="system-ui" fontWeight="700" textAnchor="middle">$24,500 LTV</text>
      {[
        { label: 'Visitas', val: '47', icon: '📅' },
        { label: 'Promedio', val: '$522', icon: '💰' },
        { label: 'No-shows', val: '0', icon: '✅' },
        { label: 'NPS', val: '98', icon: '⭐' },
      ].map((s, i) => (
        <g key={i}>
          <rect x={20 + i*82} y="120" width="74" height="56" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
          <text x={57 + i*82} y="142" fontSize="14" fontFamily="system-ui" textAnchor="middle">{s.icon}</text>
          <text x={57 + i*82} y="158" fontSize="12" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="800" fontFamily="system-ui" textAnchor="middle">{s.val}</text>
          <text x={57 + i*82} y="170" fontSize="7" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui" textAnchor="middle">{s.label}</text>
        </g>
      ))}
      <rect x="20" y="186" width="320" height="56" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="204" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Última visita: Mar 28 · 8:00 PM · $650</text>
      <text x="36" y="220" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Preferencia: Terraza · Vino tinto · Sin gluten</text>
      <rect x="256" y="196" width="74" height="36" rx="8" fill="#f97316"/>
      <text x="293" y="218" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Enviar cupón</text>
    </svg>
  );
}

function IllustrationEvents({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <defs>
        <linearGradient id="evt1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f97316"/>
          <stop offset="100%" stopColor="#dc2626"/>
        </linearGradient>
      </defs>
      <rect x="20" y="20" width="220" height="140" rx="14" fill="url(#evt1)"/>
      <text x="38" y="52" fontSize="22" fontFamily="system-ui">🎶</text>
      <text x="38" y="72" fontSize="14" fill="white" fontWeight="900" fontFamily="system-ui">Noche de Jazz</text>
      <text x="38" y="88" fontSize="9" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">Viernes 18 Abr · 8:00 PM</text>
      <text x="38" y="102" fontSize="9" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">Restaurante La Hacienda</text>
      <rect x="38" y="114" width="80" height="30" rx="8" fill="white"/>
      <text x="78" y="133" fontSize="9" fill="#f97316" fontWeight="800" fontFamily="system-ui" textAnchor="middle">Comprar $350</text>
      <rect x="130" y="114" width="80" height="30" rx="8" fill="rgba(255,255,255,0.2)"/>
      <text x="170" y="133" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">120 / 150 🎫</text>
      <rect x="20" y="172" width="106" height="70" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="198" fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">QR Check-in</text>
      <rect x="40" y="204" width="36" height="28" rx="4" fill={isDark ? '#334155' : '#f1f5f9'}/>
      <text x="58" y="222" fontSize="20" fontFamily="system-ui" textAnchor="middle">⬛</text>
      <rect x="134" y="172" width="106" height="70" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="150" y="196" fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">Boletos vendidos</text>
      <text x="187" y="222" fontSize="22" fill="#f97316" fontWeight="900" fontFamily="system-ui" textAnchor="middle">120</text>
      <rect x="256" y="20" width="84" height="222" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="298" y="46" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">Próximos</text>
      {['Cena Maridaje', 'Día del Niño', 'Brunch Dom'].map((e, i) => (
        <g key={i}>
          <rect x="264" y={58 + i*62} width="68" height="50" rx="8" fill={isDark ? '#1e293b' : '#f8fafc'}/>
          <text x="298" y={76 + i*62} fontSize="8" fill="#f97316" fontWeight="700" fontFamily="system-ui" textAnchor="middle">{e}</text>
          <text x="298" y={90 + i*62} fontSize="7" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui" textAnchor="middle">Abr {20 + i*7}</text>
          <rect x="270" y={96 + i*62} width="56" height="8" rx="4" fill="#f97316" fillOpacity="0.2"/>
          <rect x="270" y={96 + i*62} width={[40, 28, 50][i]} height="8" rx="4" fill="#f97316"/>
        </g>
      ))}
    </svg>
  );
}

function IllustrationVoiceBot({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <circle cx="180" cy="110" r="64" fill="#f97316" fillOpacity="0.08"/>
      <circle cx="180" cy="110" r="44" fill="#f97316" fillOpacity="0.12"/>
      <circle cx="180" cy="110" r="28" fill="#f97316"/>
      <text x="172" y="118" fontSize="22" fontFamily="system-ui">🎙</text>
      {[0,1,2,3,4,5,6,7].map(i => {
        const angle = (i / 8) * Math.PI * 2;
        const h = [20,32,18,40,24,36,16,28][i];
        return (
          <g key={i} transform={`translate(180,110) rotate(${i*45})`}>
            <rect x="-2" y="-78" width="4" height={h} rx="2" fill="#f97316" fillOpacity="0.5"/>
          </g>
        );
      })}
      <rect x="28" y="185" width="154" height="56" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="44" y="205" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">📞 Llamada en curso...</text>
      <text x="44" y="220" fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">"Quiero reservar para 4 personas"</text>
      <text x="44" y="234" fontSize="8" fill="#10b981" fontFamily="system-ui">● Entendido, ¿para qué fecha?</text>
      <rect x="192" y="185" width="140" height="56" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="208" y="203" fontSize="8" fill="#10b981" fontFamily="system-ui">✅ Reserva creada</text>
      <text x="208" y="216" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Sábado 19 Abr · 8pm</text>
      <text x="208" y="229" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">4 personas · Confirmada</text>
      <text x="208" y="234" fontSize="7" fill="#f97316" fontFamily="system-ui">Disponible 24/7 · IA GPT</text>
      <text x="180" y="50" fontSize="11" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui" textAnchor="middle">Bot de Voz con IA</text>
      <text x="180" y="66" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">Reservaciones conversacionales 24/7</text>
    </svg>
  );
}

function IllustrationNoShow({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const factors = [
    { label: 'Historial cliente', val: 85, color: '#10b981' },
    { label: 'Tiempo anticipación', val: 62, color: '#f97316' },
    { label: 'Día de semana', val: 74, color: '#3b82f6' },
    { label: 'Tamaño del grupo', val: 48, color: '#eab308' },
    { label: 'Confirmación recibida', val: 91, color: '#10b981' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="148" height="100" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="46" fontSize="10" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">Riesgo de No-Show</text>
      <circle cx="94" cy="86" r="32" fill="none" stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="6"/>
      <circle cx="94" cy="86" r="32" fill="none" stroke="#ef4444" strokeWidth="6" strokeDasharray="75 125" strokeLinecap="round" transform="rotate(-90 94 86)"/>
      <text x="94" y="82" fontSize="14" fill="#ef4444" fontWeight="900" fontFamily="system-ui" textAnchor="middle">72%</text>
      <text x="94" y="96" fontSize="7" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">ALTO</text>
      <rect x="178" y="20" width="162" height="100" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="194" y="40" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Factores de riesgo</text>
      {factors.slice(0,3).map((f, i) => (
        <g key={i}>
          <text x="194" y={56 + i*18} fontSize="7.5" fill={isDark ? '#cbd5e1' : '#475569'} fontFamily="system-ui">{f.label}</text>
          <rect x="194" y={60 + i*18} width="130" height="5" rx="2.5" fill={isDark ? '#334155' : '#e2e8f0'}/>
          <rect x="194" y={60 + i*18} width={f.val * 1.3} height="5" rx="2.5" fill={f.color}/>
        </g>
      ))}
      <rect x="20" y="132" width="320" height="110" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="152" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">⚠ Reservas de hoy con riesgo elevado</text>
      {[
        { name: 'Torres · 4p · 8pm', risk: '72%', col: '#ef4444' },
        { name: 'Sánchez · 2p · 9pm', risk: '45%', col: '#f97316' },
        { name: 'Flores · 6p · 7pm', risk: '18%', col: '#10b981' },
      ].map((r, i) => (
        <g key={i}>
          <text x="36" y={172 + i*26} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontFamily="system-ui" fontWeight="600">{r.name}</text>
          <rect x="248" y={160 + i*26} width="78" height="18" rx="9" fill={r.col} fillOpacity="0.15"/>
          <text x="287" y={173 + i*26} fontSize="8" fill={r.col} fontFamily="system-ui" fontWeight="700" textAnchor="middle">Riesgo {r.risk}</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationAnalytics({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const bars = [42, 68, 55, 82, 91, 74, 63];
  const days = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      {[
        { label: 'Reservas Hoy', val: '48', sub: '+12%', col: '#f97316', x: 20 },
        { label: 'Ocupación', val: '86%', sub: '+4%', col: '#10b981', x: 126 },
        { label: 'Ingresos', val: '$28K', sub: '+22%', col: '#3b82f6', x: 232 },
      ].map((s, i) => (
        <g key={i}>
          <rect x={s.x} y="20" width="96" height="56" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
          <text x={s.x+12} y="40" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">{s.label}</text>
          <text x={s.x+12} y="58" fontSize="18" fill={s.col} fontWeight="900" fontFamily="system-ui">{s.val}</text>
          <text x={s.x+80} y="58" fontSize="8" fill="#10b981" fontFamily="system-ui" textAnchor="end">{s.sub}</text>
        </g>
      ))}
      <rect x="20" y="86" width="212" height="154" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="106" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Reservas por día</text>
      {bars.map((h, i) => (
        <g key={i}>
          <rect x={36 + i*26} y={200 - h} width="18" height={h} rx="4" fill={i === 4 ? '#f97316' : '#f97316'} fillOpacity={i === 4 ? 1 : 0.4}/>
          <text x={45 + i*26} y="218" fontSize="7.5" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui" textAnchor="middle">{days[i]}</text>
        </g>
      ))}
      <rect x="242" y="86" width="98" height="154" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="258" y="106" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Distribución</text>
      {[
        { label: 'Interior', pct: 48, col: '#f97316' },
        { label: 'Terraza', pct: 32, col: '#3b82f6' },
        { label: 'Privado', pct: 20, col: '#8b5cf6' },
      ].map((d, i) => (
        <g key={i}>
          <rect x="258" y={120 + i*34} width="66" height="6" rx="3" fill={isDark ? '#334155' : '#e2e8f0'}/>
          <rect x="258" y={120 + i*34} width={d.pct * 0.66} height="6" rx="3" fill={d.col}/>
          <text x="258" y={114 + i*34} fontSize="7.5" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">{d.label}</text>
          <text x="324" y={114 + i*34} fontSize="7.5" fill={d.col} fontFamily="system-ui" fontWeight="700" textAnchor="end">{d.pct}%</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationLocations({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const locs = [
    { x: 100, y: 100, name: 'Centro', res: 42, col: '#f97316' },
    { x: 240, y: 80,  name: 'Polanco', res: 38, col: '#3b82f6' },
    { x: 170, y: 160, name: 'Condesa', res: 29, col: '#10b981' },
    { x: 80,  y: 170, name: 'Roma',   res: 21, col: '#8b5cf6' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="200" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="20" y="20" width="320" height="200" rx="14" fill={isDark ? '#1e3a5f' : '#dbeafe'} fillOpacity="0.4"/>
      {[60,100,140,180].map(y => (
        <line key={y} x1="20" y1={y} x2="340" y2={y} stroke={isDark ? '#334155' : '#bfdbfe'} strokeWidth="0.5"/>
      ))}
      {[80,140,200,260,320].map(x => (
        <line key={x} x1={x} y1="20" x2={x} y2="220" stroke={isDark ? '#334155' : '#bfdbfe'} strokeWidth="0.5"/>
      ))}
      {locs.map((l, i) => (
        <g key={i}>
          <circle cx={l.x} cy={l.y} r="18" fill={l.col} fillOpacity="0.2"/>
          <circle cx={l.x} cy={l.y} r="10" fill={l.col}/>
          <text x={l.x} y={l.y+4} fontSize="9" fill="white" fontWeight="800" fontFamily="system-ui" textAnchor="middle">🍽</text>
          <rect x={l.x-28} y={l.y-42} width="56" height="22" rx="6" fill={card}/>
          <text x={l.x} y={l.y-30} fontSize="8" fill={l.col} fontWeight="700" fontFamily="system-ui" textAnchor="middle">{l.name}</text>
          <text x={l.x} y={l.y-20} fontSize="7" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">{l.res} hoy</text>
        </g>
      ))}
      <rect x="20" y="228" width="320" height="20" rx="0"/>
      <rect x="28" y="232" width="290" height="12" rx="6" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="44" y="241" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Total hoy: 130 reservas · 4 ubicaciones activas</text>
    </svg>
  );
}

function IllustrationExperiences({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <defs>
        <linearGradient id="exp1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#7c3aed"/>
          <stop offset="100%" stopColor="#f97316"/>
        </linearGradient>
      </defs>
      <rect x="20" y="20" width="200" height="130" rx="14" fill="url(#exp1)"/>
      <text x="38" y="52" fontSize="20" fontFamily="system-ui">🍷</text>
      <text x="38" y="72" fontSize="13" fill="white" fontWeight="900" fontFamily="system-ui">Cena Maridaje</text>
      <text x="38" y="88" fontSize="8" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">Experiencia exclusiva 5 tiempos</text>
      <text x="38" y="104" fontSize="18" fill="white" fontWeight="900" fontFamily="system-ui">$1,850 / persona</text>
      <text x="38" y="120" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">Máx. 12 personas · Sábados 7:00 PM</text>
      <rect x="38" y="128" width="80" height="16" rx="8" fill="rgba(255,255,255,0.25)"/>
      <text x="78" y="140" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">4 lugares restantes</text>
      {[
        { title: 'Clase de Cocina', price: '$750', icon: '👨‍🍳', x: 232 },
        { title: 'Brunch Familiar', price: '$450', icon: '🥞', x: 232 },
      ].map((e, i) => (
        <g key={i}>
          <rect x={e.x} y={20 + i*68} width="108" height="60" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
          <text x={e.x+12} y={46 + i*68} fontSize="18" fontFamily="system-ui">{e.icon}</text>
          <text x={e.x+46} y={40 + i*68} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">{e.title}</text>
          <text x={e.x+46} y={54 + i*68} fontSize="10" fill="#f97316" fontWeight="800" fontFamily="system-ui">{e.price}</text>
          <rect x={e.x+12} y={65 + i*68} width="84" height="10" rx="5" fill="#f97316"/>
          <text x={e.x+54} y={74 + i*68} fontSize="7" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Reservar →</text>
        </g>
      ))}
      <rect x="20" y="162" width="320" height="78" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="182" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Ingresos por experiencias este mes</text>
      <text x="36" y="206" fontSize="24" fill="#7c3aed" fontWeight="900" fontFamily="system-ui">$62,400</text>
      <text x="36" y="224" fontSize="8" fill="#10b981" fontFamily="system-ui">▲ +38% vs mes anterior · 42 experiencias vendidas</text>
    </svg>
  );
}

function IllustrationMarketing({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="80" rx="14" fill="#f97316"/>
      <circle cx="320" cy="20" r="70" fill="rgba(255,255,255,0.07)"/>
      <text x="40" y="50" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">🎟 Código Promocional</text>
      <rect x="40" y="60" width="160" height="28" rx="8" fill="rgba(255,255,255,0.2)"/>
      <text x="120" y="79" fontSize="14" fill="white" fontWeight="900" fontFamily="system-ui" textAnchor="middle" letterSpacing="4">VERANO25</text>
      <text x="214" y="60" fontSize="9" fill="rgba(255,255,255,0.9)" fontFamily="system-ui">25% descuento</text>
      <text x="214" y="74" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">Válido hasta 30 Abr</text>
      <text x="214" y="88" fontSize="8" fill="rgba(255,255,255,0.7)" fontFamily="system-ui">78 / 100 usos</text>
      {[
        { name: 'CUMPLE20', desc: '20% en tu cumpleaños', used: '142', col: '#10b981' },
        { name: 'PROMO2P', desc: 'Mesa para 2 + vino',   used: '38',  col: '#3b82f6' },
        { name: 'MARTES15', desc: '15% los martes',       used: '291', col: '#8b5cf6' },
      ].map((c, i) => (
        <g key={i}>
          <rect x="20" y={116 + i*46} width="320" height="38" rx="8" fill={card} stroke={isDark ? '#334155' : '#f1f5f9'} strokeWidth="1"/>
          <rect x="20" y={116 + i*46} width="4" height="38" rx="2" fill={c.col}/>
          <text x="36" y={130 + i*46} fontSize="10" fill={c.col} fontWeight="800" fontFamily="system-ui" letterSpacing="1">{c.name}</text>
          <text x="36" y={146 + i*46} fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">{c.desc}</text>
          <text x="320" y={134 + i*46} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui" textAnchor="end">{c.used} usos</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationBirthday({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="100" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="50" fontSize="28" fontFamily="system-ui">🎂</text>
      <text x="80" y="46" fontSize="13" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="800" fontFamily="system-ui">¡Feliz cumpleaños, María! 🎉</text>
      <text x="80" y="62" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Restaurante La Hacienda te regala algo especial</text>
      <rect x="80" y="74" width="220" height="36" rx="10" fill="#f97316" fillOpacity="0.1" stroke="#f97316" strokeWidth="1" strokeDasharray="4 2"/>
      <text x="190" y="88" fontSize="10" fill="#f97316" fontWeight="800" fontFamily="system-ui" textAnchor="middle">🎁 CUPÓN: CUMPLE2026</text>
      <text x="190" y="102" fontSize="8" fill="#f97316" fontFamily="system-ui" textAnchor="middle">20% de descuento en tu próxima visita</text>
      <rect x="20" y="134" width="152" height="110" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="156" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Canales de envío</text>
      {[
        { icon: '📱', label: 'WhatsApp', col: '#25d366' },
        { icon: '📧', label: 'Email',    col: '#3b82f6' },
        { icon: '💬', label: 'SMS',      col: '#f97316' },
      ].map((ch, i) => (
        <g key={i}>
          <rect x="36" y={164 + i*30} width="120" height="22" rx="6" fill={ch.col} fillOpacity="0.1"/>
          <text x="52" y={179 + i*30} fontSize="10" fontFamily="system-ui">{ch.icon}</text>
          <text x="68" y="179" fontSize="8" fill={ch.col} fontWeight="700" fontFamily="system-ui" y={179 + i*30}>{ch.label} · Auto</text>
        </g>
      ))}
      <rect x="188" y="134" width="152" height="110" rx="12" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="204" y="156" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Próximos cumpleaños</text>
      {[
        { name: 'Carlos R.', date: 'Hoy', col: '#f97316' },
        { name: 'Laura M.', date: 'Mañana', col: '#3b82f6' },
        { name: 'Pedro G.', date: '3 días', col: '#10b981' },
      ].map((b, i) => (
        <g key={i}>
          <text x="204" y={172 + i*28} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="600" fontFamily="system-ui">{b.name}</text>
          <rect x="282" y={160 + i*28} width="50" height="16" rx="8" fill={b.col} fillOpacity="0.15"/>
          <text x="307" y={172 + i*28} fontSize="7.5" fill={b.col} fontWeight="700" fontFamily="system-ui" textAnchor="middle">{b.date}</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationWidget({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const code = isDark ? '#1e293b' : '#0f172a';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="156" rx="12" fill={code} stroke={isDark ? '#475569' : '#334155'} strokeWidth="1"/>
      <circle cx="40" cy="40" r="6" fill="#ef4444"/>
      <circle cx="56" cy="40" r="6" fill="#f59e0b"/>
      <circle cx="72" cy="40" r="6" fill="#10b981"/>
      <text x="36" y="66" fontSize="8.5" fill="#64748b" fontFamily="monospace">{'<'}<text fill="#10b981">{'script'}</text> <text fill="#60a5fa">{'src'}</text>=<text fill="#f59e0b">{'"https://widget.okreserva.mx/v1.js"'}</text>{'>'}</text>
      <text x="36" y="82" fontSize="8.5" fill="#64748b" fontFamily="monospace">{'<'}<text fill="#10b981">{'script'}</text>{'>'}</text>
      <text x="52" y="98" fontSize="8.5" fill="#a78bfa" fontFamily="monospace">OkReserva.<text fill="#60a5fa">{'init'}</text>{'({'}</text>
      <text x="68" y="114" fontSize="8.5" fill="#fbbf24" fontFamily="monospace">restaurant_id: <text fill="#f59e0b">{'"la-hacienda"'}</text>,</text>
      <text x="68" y="130" fontSize="8.5" fill="#fbbf24" fontFamily="monospace">color: <text fill="#f59e0b">{'"#f97316"'}</text>,</text>
      <text x="68" y="146" fontSize="8.5" fill="#fbbf24" fontFamily="monospace">lang: <text fill="#f59e0b">{'"es"'}</text></text>
      <text x="52" y="162" fontSize="8.5" fill="#a78bfa" fontFamily="monospace">{'});'}</text>
      <rect x="20" y="186" width="148" height="60" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="204" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Vista previa widget</text>
      <rect x="36" y="210" width="116" height="28" rx="8" fill="#f97316"/>
      <text x="94" y="228" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">🗓 Reservar Mesa</text>
      <rect x="184" y="186" width="156" height="60" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="200" y="204" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">Estadísticas del widget</text>
      <text x="200" y="222" fontSize="11" fill="#f97316" fontWeight="800" fontFamily="system-ui">4,821 clics</text>
      <text x="200" y="238" fontSize="8" fill="#10b981" fontFamily="system-ui">1,240 reservas este mes</text>
    </svg>
  );
}

function IllustrationQRCheckin({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="148" height="220" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <rect x="20" y="20" width="148" height="40" rx="14" fill="#f97316"/>
      <rect x="20" y="44" width="148" height="16" fill="#f97316"/>
      <text x="94" y="46" fontSize="9" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Tu Reservación</text>
      <rect x="48" y="72" width="92" height="92" rx="8" fill={isDark ? '#334155' : '#f8fafc'}/>
      {[0,1,2,3].map(row => [0,1,2,3].map(col => (
        <rect key={`${row}-${col}`} x={52 + col*21} y={76 + row*21} width="14" height="14" rx="2"
          fill={Math.random() > 0.4 ? (isDark ? '#f1f5f9' : '#1e293b') : 'transparent'} fillOpacity="0.9"/>
      )))}
      <text x="94" y="184" fontSize="10" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="800" fontFamily="system-ui" textAnchor="middle">García · 4p</text>
      <text x="94" y="198" fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">Sáb 19 Abr · 8:00 PM</text>
      <rect x="36" y="208" width="116" height="24" rx="8" fill="#f97316"/>
      <text x="94" y="223" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">Escanear al llegar</text>
      <rect x="186" y="20" width="154" height="220" rx="14" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="263" y="50" fontSize="9" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">Check-in de hoy</text>
      {[
        { name: 'García · 4p', time: '19:58', ok: true },
        { name: 'López · 2p',  time: '20:02', ok: true },
        { name: 'Torres · 6p', time: '—',     ok: false },
        { name: 'Flores · 3p', time: '20:15', ok: true },
      ].map((r, i) => (
        <g key={i}>
          <rect x="198" y={60 + i*46} width="130" height="38" rx="8" fill={isDark ? '#1e293b' : '#f8fafc'}/>
          <text x="210" y={74 + i*46} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="600" fontFamily="system-ui">{r.name}</text>
          <text x="210" y={88 + i*46} fontSize="8" fill={isDark ? '#64748b' : '#94a3b8'} fontFamily="system-ui">{r.time}</text>
          <text x="312" y={80 + i*46} fontSize="14" fontFamily="system-ui">{r.ok ? '✅' : '⏳'}</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationWaitlist({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="52" rx="12" fill="#f97316"/>
      <text x="36" y="42" fontSize="11" fill="white" fontWeight="800" fontFamily="system-ui">⏳ Lista de Espera</text>
      <text x="36" y="58" fontSize="8" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">Restaurante lleno · 4 grupos en espera · ~25 min promedio</text>
      {[
        { pos: 1, name: 'Familia Ruiz',  pers: '5p', wait: '~8 min',  col: '#10b981' },
        { pos: 2, name: 'Carlos López',  pers: '2p', wait: '~15 min', col: '#f97316' },
        { pos: 3, name: 'Sandra Torres', pers: '4p', wait: '~22 min', col: '#f97316' },
        { pos: 4, name: 'Mesa Sánchez',  pers: '6p', wait: '~30 min', col: '#94a3b8' },
      ].map((w, i) => (
        <g key={i}>
          <rect x="20" y={86 + i*42} width="320" height="34" rx="8" fill={card} stroke={isDark ? '#334155' : '#f1f5f9'} strokeWidth="1"/>
          <circle cx="44" cy={103 + i*42} r="12" fill={w.col} fillOpacity="0.15"/>
          <text x="44" y={107 + i*42} fontSize="10" fill={w.col} fontWeight="800" fontFamily="system-ui" textAnchor="middle">#{w.pos}</text>
          <text x="68" y={99 + i*42} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">{w.name}</text>
          <text x="68" y={113 + i*42} fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">{w.pers}</text>
          <text x="220" y={105 + i*42} fontSize="9" fill={w.col} fontWeight="700" fontFamily="system-ui">{w.wait}</text>
          <rect x="276" y={95 + i*42} width="52" height="18" rx="9" fill={i === 0 ? '#10b981' : isDark ? '#334155' : '#f1f5f9'}/>
          <text x="302" y={108 + i*42} fontSize="7.5" fill={i === 0 ? 'white' : (isDark ? '#64748b' : '#94a3b8')} fontFamily="system-ui" fontWeight="600" textAnchor="middle">{i === 0 ? 'Notificar' : 'En espera'}</text>
        </g>
      ))}
    </svg>
  );
}

function IllustrationIntegrations({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const integrations = [
    { name: 'OpenTable', color: '#ef4444', icon: '🍽' },
    { name: 'TheFork',   color: '#10b981', icon: '🍴' },
    { name: 'Google',    color: '#3b82f6', icon: 'G' },
    { name: 'Resy',      color: '#8b5cf6', icon: 'R' },
    { name: 'WA API',    color: '#25d366', icon: '💬' },
    { name: 'Stripe',    color: '#6366f1', icon: '💳' },
    { name: 'Mailchimp', color: '#f59e0b', icon: '📧' },
    { name: 'Zapier',    color: '#f97316', icon: '⚡' },
    { name: 'OpenAI',    color: '#10b981', icon: '🤖' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <circle cx="180" cy="130" r="30" fill="#f97316"/>
      <text x="172" y="137" fontSize="22" fontFamily="system-ui">🔗</text>
      {integrations.map((int, i) => {
        const angle = (i / integrations.length) * Math.PI * 2 - Math.PI / 2;
        const r = 100;
        const x = 180 + r * Math.cos(angle);
        const y = 130 + r * Math.sin(angle);
        return (
          <g key={i}>
            <line x1="180" y1="130" x2={x} y2={y} stroke={int.color} strokeWidth="1" strokeDasharray="3 3" strokeOpacity="0.5"/>
            <circle cx={x} cy={y} r="22" fill={card} stroke={int.color} strokeWidth="1.5"/>
            <text x={x} y={y+4} fontSize={int.icon.length === 1 ? '11' : '14'} fill={int.icon.length === 1 ? int.color : undefined} fontWeight="800" fontFamily="system-ui" textAnchor="middle">{int.icon}</text>
            <text x={x} y={y+18} fontSize="5.5" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui" textAnchor="middle">{int.name}</text>
          </g>
        );
      })}
      <text x="180" y="172" fontSize="8" fill="white" fontWeight="700" fontFamily="system-ui" textAnchor="middle">OkReserva</text>
    </svg>
  );
}

function IllustrationAlerts({ isDark }) {
  const bg = isDark ? '#1e293b' : '#fff7ed';
  const card = isDark ? '#0f172a' : '#ffffff';
  const alerts = [
    { icon: '🔴', title: 'No-show detectado',      sub: 'Torres · Mesa 4 · 8:00 PM',   time: 'hace 2 min', col: '#ef4444' },
    { icon: '🟠', title: 'VIP llegando en 15 min', sub: 'Sr. García · Mesa reservada',  time: 'hace 5 min', col: '#f97316' },
    { icon: '🟢', title: 'Reserva confirmada',     sub: 'María López · 4p · Terraza',   time: 'hace 8 min', col: '#10b981' },
    { icon: '🔵', title: 'Lista de espera: 3',     sub: 'Tiempo estimado 20 minutos',   time: 'hace 12 min', col: '#3b82f6' },
  ];
  return (
    <svg viewBox="0 0 360 260" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto rounded-xl">
      <rect width="360" height="260" rx="16" fill={bg}/>
      <rect x="20" y="20" width="320" height="36" rx="10" fill={card} stroke={isDark ? '#334155' : '#e2e8f0'} strokeWidth="1"/>
      <text x="36" y="43" fontSize="10" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">🔔 Centro de Alertas · 4 nuevas</text>
      <rect x="290" y="28" width="40" height="20" rx="10" fill="#ef4444"/>
      <text x="310" y="42" fontSize="9" fill="white" fontWeight="800" fontFamily="system-ui" textAnchor="middle">4 🚨</text>
      {alerts.map((a, i) => (
        <g key={i}>
          <rect x="20" y={70 + i*46} width="320" height="38" rx="10" fill={card} stroke={a.col} strokeWidth="1" strokeOpacity="0.4"/>
          <rect x="20" y={70 + i*46} width="4" height="38" rx="2" fill={a.col}/>
          <text x="36" y={84 + i*46} fontSize="14" fontFamily="system-ui">{a.icon}</text>
          <text x="60" y={84 + i*46} fontSize="9" fill={isDark ? '#f1f5f9' : '#1e293b'} fontWeight="700" fontFamily="system-ui">{a.title}</text>
          <text x="60" y={98 + i*46} fontSize="8" fill={isDark ? '#94a3b8' : '#64748b'} fontFamily="system-ui">{a.sub}</text>
          <text x="316" y={84 + i*46} fontSize="7" fill={isDark ? '#475569' : '#94a3b8'} fontFamily="system-ui" textAnchor="end">{a.time}</text>
          <rect x="280" y={92 + i*46} width="36" height="12" rx="6" fill={a.col} fillOpacity="0.15"/>
          <text x="298" y={102 + i*46} fontSize="6.5" fill={a.col} fontFamily="system-ui" fontWeight="700" textAnchor="middle">Resolver</text>
        </g>
      ))}
    </svg>
  );
}

// ===== FEATURES DATA =====
const features = [
  {
    id: 'libro', icon: CalendarDays,
    title: 'Libro Digital', subtitle: 'Gestión visual de reservaciones',
    description: 'Visualiza todas tus reservaciones en una línea de tiempo intuitiva. Confirma, cancela y gestiona con un solo clic. Estadísticas en tiempo real de tu ocupación.',
    component: IllustrationDigitalBook,
    highlights: ['Vista de timeline interactiva', 'Confirmación con un clic', 'Estados en tiempo real', 'Exportación a CSV/PDF']
  },
  {
    id: 'floor', icon: Map,
    title: 'Plano de Sala', subtitle: 'Editor visual drag-and-drop',
    description: 'Diseña tu restaurante de manera visual. Arrastra mesas, crea zonas y simula ocupación. Ideal para optimizar el flujo de clientes.',
    component: IllustrationFloorPlan,
    highlights: ['Editor drag-and-drop', 'Simulación de ocupación', 'Múltiples zonas', 'Capacidad automática']
  },
  {
    id: 'crm', icon: Users,
    title: 'CRM Inteligente', subtitle: 'Conoce a tus clientes a fondo',
    description: 'Perfil 360° de cada cliente. Historial de visitas, preferencias alimentarias, alergias, valor de vida y más. Envía cupones personalizados.',
    component: IllustrationCRM,
    highlights: ['Perfil completo 360°', 'Historial de visitas', 'Envío de cupones', 'Segmentación inteligente']
  },
  {
    id: 'ouser', icon: Smartphone,
    title: 'Portal del Cliente (OUser)', subtitle: 'App privada para tus comensales',
    description: 'Tus clientes acceden a su propio portal con login por PIN. Ven sus reservaciones, puntos de lealtad, beneficios exclusivos y eventos. Experiencia VIP digital.',
    component: IllustrationPortal,
    highlights: ['Login seguro con PIN', 'Mis reservaciones', 'Puntos de lealtad', 'Check-in con QR']
  },
  {
    id: 'loyalty', icon: Trophy,
    title: 'Programa de Lealtad', subtitle: 'Bronce · Plata · Oro · Diamante',
    description: 'Sistema de puntos con 4 niveles de membresía. Tus clientes acumulan puntos en cada visita y desbloquean beneficios exclusivos. Retención automática.',
    component: IllustrationLoyalty,
    highlights: ['4 niveles de membresía', 'Puntos por visita', 'Beneficios exclusivos', 'Retención automática']
  },
  {
    id: 'events', icon: PartyPopper,
    title: 'Gestión de Eventos', subtitle: 'Venta de boletos integrada',
    description: 'Crea eventos especiales, vende boletos online con QR y gestiona el check-in. Galería multimedia y sharing en redes sociales.',
    component: IllustrationEvents,
    highlights: ['Venta de boletos online', 'Check-in con QR', 'Galería y videos', 'Compartir en redes']
  },
  {
    id: 'giftcards', icon: Gift,
    title: 'Gift Cards Digitales', subtitle: 'Regala experiencias gastronómicas',
    description: 'Crea y vende gift cards digitales personalizadas. Tus clientes las compran como regalo y se pueden canjear en cualquier visita. Ideal para incrementar ingresos.',
    component: IllustrationGiftCards,
    highlights: ['Gift cards personalizadas', 'Envío por WhatsApp', 'Canje fácil', 'Ingreso anticipado']
  },
  {
    id: 'nps', icon: Star,
    title: 'NPS & Satisfacción', subtitle: 'Feedback post-visita automático',
    description: 'Envía encuestas automáticas después de cada visita. Mide el NPS (Net Promoter Score) y analiza la satisfacción en tiempo real. Detecta áreas de mejora.',
    component: IllustrationNPS,
    highlights: ['Encuestas automáticas', 'NPS en tiempo real', 'Análisis por categoría', 'Respuesta a reseñas']
  },
  {
    id: 'voice', icon: Mic,
    title: 'Bot de Voz con IA', subtitle: 'Reservaciones conversacionales 24/7',
    description: 'Asistente virtual que entiende lenguaje natural en español e inglés. Toma reservaciones mientras duermes. Integrado con tu sistema.',
    component: IllustrationVoiceBot,
    highlights: ['IA conversacional GPT', 'Disponible 24/7', 'Español e inglés', 'Integración total']
  },
  {
    id: 'whatsapp', icon: MessageCircle,
    title: 'WhatsApp Automatizado', subtitle: 'Mensajería inteligente sin esfuerzo',
    description: 'Envía confirmaciones, recordatorios, felicitaciones de cumpleaños y encuestas de satisfacción directamente por WhatsApp. Todo automático y personalizado.',
    component: IllustrationWhatsApp,
    highlights: ['Confirmaciones auto', 'Recordatorios 24h antes', 'Follow-up post-visita', 'Campañas personalizadas']
  },
  {
    id: 'booking', icon: Globe,
    title: 'Booking Page Pública', subtitle: 'Tu página de reservas propia',
    description: 'Una página pública hermosa y personalizable para que tus clientes reserven directamente. Sin comisiones de terceros. Tu marca, tu dominio.',
    component: IllustrationBookingPage,
    highlights: ['Página personalizada', 'Sin comisiones', 'Tu marca y colores', 'SEO optimizado']
  },
  {
    id: 'deposits', icon: CreditCard,
    title: 'Depósitos y Garantías', subtitle: 'Elimina los no-shows con pagos',
    description: 'Solicita un depósito o cargo de garantía al momento de la reservación. Se descuenta del total de la cuenta. Reduce los no-shows hasta un 70%.',
    component: IllustrationDeposits,
    highlights: ['Depósito configurable', 'Cargo de garantía', 'Reduce no-shows 70%', 'Reembolso automático']
  },
  {
    id: 'noshow', icon: TrendingDown,
    title: 'Predicción No-Shows', subtitle: 'Machine Learning predictivo',
    description: 'Algoritmo que analiza 5 factores de riesgo para predecir qué reservaciones podrían no presentarse. Actúa preventivamente.',
    component: IllustrationNoShow,
    highlights: ['5 factores de riesgo', 'Alertas automáticas', 'Recomendaciones', 'Historial de cliente']
  },
  {
    id: 'allergens', icon: Heart,
    title: 'Gestión de Alérgenos', subtitle: 'Seguridad alimentaria garantizada',
    description: 'Registra y gestiona los alérgenos de cada cliente. El equipo recibe alertas automáticas antes de cada servicio. Cumple con normativas de seguridad alimentaria.',
    component: IllustrationAllergens,
    highlights: ['14 alérgenos EFSA', 'Alertas al equipo', 'Perfil por cliente', 'Reportes de seguridad']
  },
  {
    id: 'analytics', icon: BarChart3,
    title: 'Analíticas Avanzadas', subtitle: 'Métricas y reportes detallados',
    description: 'Dashboard completo con métricas clave de tu negocio. Reportes de ocupación, ingresos, tendencias y comparativas. Exportación a PDF y Excel.',
    component: IllustrationAnalytics,
    highlights: ['Dashboard en tiempo real', 'Reportes detallados', 'Tendencias y comparativas', 'Exportación PDF/Excel']
  },
  {
    id: 'locations', icon: Building2,
    title: 'Multi-Ubicación', subtitle: 'Para cadenas de restaurantes',
    description: 'Una cuenta, todas tus sucursales. Dashboard consolidado, CRM compartido y gestión centralizada. Cambio de ubicación instantáneo.',
    component: IllustrationLocations,
    highlights: ['Dashboard unificado', 'CRM compartido', 'Analíticas consolidadas', 'Gestión centralizada']
  },
  {
    id: 'experiences', icon: Sparkles,
    title: 'Experiencias Gastronómicas', subtitle: 'Vende experiencias únicas',
    description: 'Crea y vende experiencias gastronómicas personalizadas. Cenas maridaje, degustaciones, clases de cocina y más. Widget embebible con reservación directa.',
    component: IllustrationExperiences,
    highlights: ['Precios por persona/grupo', 'Slots de horarios', 'Widget de venta', 'Galería y videos']
  },
  {
    id: 'marketing', icon: Megaphone,
    title: 'Marketing y Promociones', subtitle: 'Códigos promocionales',
    description: 'Crea códigos de descuento, campañas especiales y promociones para fechas importantes. Seguimiento de conversión incluido.',
    component: IllustrationMarketing,
    highlights: ['Códigos promocionales', 'Campañas especiales', 'Seguimiento conversión', 'Fechas especiales']
  },
  {
    id: 'birthday', icon: Cake,
    title: 'Cumpleaños Automáticos', subtitle: 'Fidelización inteligente',
    description: 'Envía felicitaciones automáticas con cupones de descuento a tus clientes en su cumpleaños. Email, SMS y WhatsApp integrados.',
    component: IllustrationBirthday,
    highlights: ['Mensajes automáticos', 'Cupones personalizados', 'Multi-canal', 'Plantillas editables']
  },
  {
    id: 'widget', icon: Code2,
    title: 'Widget Embebible', subtitle: 'Para tu sitio web',
    description: 'Integra reservaciones directamente en tu sitio web. Widget personalizable con los colores de tu marca. Instalación con un solo código.',
    component: IllustrationWidget,
    highlights: ['Fácil integración', 'Personalizable', 'Responsive', 'Un solo código']
  },
  {
    id: 'qrcheckin', icon: QrCode,
    title: 'QR Check-in', subtitle: 'Check-in sin contacto',
    description: 'Genera códigos QR únicos para cada reservación. Tus clientes pueden hacer check-in escaneando el código al llegar. Rápido, moderno y sin contacto.',
    component: IllustrationQRCheckin,
    highlights: ['QR por reservación', 'Check-in instantáneo', 'Compartir por WhatsApp', 'Descarga y email']
  },
  {
    id: 'waitlist', icon: Clock,
    title: 'Lista de Espera', subtitle: 'Gestión inteligente de cola',
    description: 'Cuando tu restaurante está lleno, los clientes pueden unirse a la lista de espera. Notificaciones automáticas cuando hay disponibilidad.',
    component: IllustrationWaitlist,
    highlights: ['Cola inteligente', 'Notificaciones SMS', 'Tiempo estimado', 'Registro con QR']
  },
  {
    id: 'integrations', icon: Globe,
    title: 'Integraciones', subtitle: '11 plataformas conectadas',
    description: 'Conecta con OpenTable, Resy, TheFork, Google Reserve y más. Sincroniza reservaciones automáticamente y gestiona todo desde un solo lugar.',
    component: IllustrationIntegrations,
    highlights: ['OpenTable, Resy, TheFork', 'Google Reserve', 'Sincronización automática', 'API universal']
  },
  {
    id: 'alerts', icon: ShieldCheck,
    title: 'Sistema de Alertas', subtitle: 'Notificaciones críticas',
    description: 'Recibe alertas en tiempo real sobre reservaciones pendientes, no-shows, VIPs y situaciones importantes. Nunca pierdas un momento crítico.',
    component: IllustrationAlerts,
    highlights: ['Alertas en tiempo real', 'Notificaciones push', 'Priorización inteligente', 'Panel de control']
  },
  {
    id: 'okwallet', icon: Wallet,
    title: 'OkWallet — Cartera Digital', subtitle: 'Pagos y saldo integrado',
    description: 'Cada restaurante tiene su propia cartera digital. Recibe depósitos de clientes, acumula saldo y paga servicios de OkReserva directamente desde tu balance. Sin comisiones adicionales.',
    component: IllustrationDeposits,
    highlights: ['Cartera por restaurante', 'Historial de transacciones', 'Recarga y retiro', 'Sin comisión en pagos internos']
  },
  {
    id: 'multicurrency', icon: CreditCard,
    title: 'Multi-Moneda', subtitle: '15 divisas internacionales',
    description: 'Gestiona tu negocio en la moneda de tu país. Soporte para 15 monedas: MXN, USD, EUR, GBP, COP, ARS, CLP, BRL, PEN, CRC, GTQ, BOB, PYG, UYU y DOP. Cambia con un clic desde cualquier pantalla.',
    component: IllustrationGiftCards,
    highlights: ['15 monedas Stripe', 'MXN por defecto', 'Cambio instantáneo', 'Formato local automático']
  },
  {
    id: 'acceso', icon: Star,
    title: 'Acceso Garantizado', subtitle: 'Planes exclusivos de membresía',
    description: 'Crea planes de membresía para que tus clientes garanticen su lugar siempre. Beneficios exclusivos, acceso preferencial y upgrades automáticos. Genera ingresos recurrentes predecibles.',
    component: IllustrationLoyalty,
    highlights: ['Planes personalizables', 'Beneficios exclusivos', 'Pago recurrente', 'Gestión de miembros']
  },
  {
    id: 'menus', icon: Heart,
    title: 'Menús Digitales Interactivos', subtitle: 'Carta QR + pedido anticipado',
    description: 'Crea cartas digitales hermosas con fotos, alérgenos, opciones veganas y precios. Tus clientes pueden pedir anticipadamente al hacer su reservación. Aumenta el ticket promedio.',
    component: IllustrationExperiences,
    highlights: ['Carta QR personalizable', 'Pedido anticipado', 'Gestión de alérgenos', 'Fotos y categorías']
  },
];

// ===== FEATURE SECTION COMPONENT =====
function FeatureSection({ feature, index, isDark }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  const isEven = index % 2 === 0;
  const IllustrationComponent = feature.component;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const Icon = feature.icon;

  return (
    <div
      ref={ref}
      className={cn(
        "grid lg:grid-cols-2 gap-8 lg:gap-16 items-center py-16 lg:py-20 transition-all duration-1000",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      )}
    >
      <div className={cn("space-y-6", !isEven && "lg:order-2")}>
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400">
          <Icon className="h-4 w-4" />
          {feature.subtitle}
        </div>
        <h3 className="text-3xl sm:text-4xl lg:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          {feature.title}
        </h3>
        <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
          {feature.description}
        </p>
        <ul className="grid grid-cols-2 gap-3">
          {feature.highlights.map((item, i) => (
            <li key={i} className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <div className="h-5 w-5 rounded-full flex items-center justify-center bg-orange-500 text-white flex-shrink-0">
                <Check className="h-3 w-3" />
              </div>
              <span className="text-sm">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className={cn("relative", !isEven && "lg:order-1")}>
        <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-orange-500/10 dark:shadow-orange-500/5 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 p-4">
          {IllustrationComponent
            ? <IllustrationComponent isDark={isDark} />
            : (
              <img
                src={feature.image}
                alt={feature.title}
                className="w-full h-auto rounded-xl"
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling && (e.target.nextSibling.style.display = 'flex');
                }}
              />
            )
          }
        </div>
        <div className={cn(
          "absolute -z-10 w-64 h-64 rounded-full blur-3xl opacity-30 dark:opacity-20 bg-orange-400",
          isEven ? "-bottom-10 -right-10" : "-bottom-10 -left-10"
        )} />
      </div>
    </div>
  );
}

// ===== MAIN LANDING PAGE =====
export default function LandingPage() {
  const [scrollY, setScrollY] = useState(0);
  const [isDark, setIsDark] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('landing-theme');
    setIsDark(savedTheme === 'dark');
    setMounted(true);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    localStorage.setItem('landing-theme', newTheme ? 'dark' : 'light');
  };

  useEffect(() => {
    if (!mounted) return;
    const originalDark = document.documentElement.classList.contains('dark');
    if (isDark) document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
    return () => {
      if (originalDark) document.documentElement.classList.add('dark');
      else document.documentElement.classList.remove('dark');
    };
  }, [isDark, mounted]);

  if (!mounted) {
    return (
      <div className="min-h-screen bg-white" data-testid="landing-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-pulse text-orange-500">Cargando...</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn("min-h-screen overflow-x-hidden transition-colors duration-500", isDark ? "bg-gray-950" : "bg-white")}
      style={{ backgroundColor: isDark ? '#030712' : '#ffffff' }}
      data-testid="landing-page"
    >
      {/* Navigation */}
      <nav className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        scrollY > 50 ? "bg-white/90 dark:bg-gray-900/90 backdrop-blur-xl shadow-sm" : "bg-transparent"
      )}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <span className="flex items-center gap-2">
            <img
              src={okReservaLogo}
              alt="OkReserva"
              className="h-8"
              style={{ filter: isDark ? 'brightness(0) invert(1)' : 'none' }}
            />
          </span>
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" onClick={toggleTheme}
              className="rounded-full w-10 h-10 hover:bg-gray-100 dark:hover:bg-gray-800"
              data-testid="theme-toggle">
              {isDark ? <Sun className="h-5 w-5 text-orange-400" /> : <Moon className="h-5 w-5 text-gray-600" />}
            </Button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-orange-50 via-white to-amber-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950" />
          <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-orange-200/40 dark:bg-orange-500/10 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-amber-200/40 dark:bg-amber-500/10 rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400 text-sm font-medium">
                <Sparkles className="h-4 w-4" />
                Plataforma #1 en México
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-gray-900 dark:text-white">
                El futuro de las
                <span className="block bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500 bg-clip-text text-transparent">
                  reservaciones
                </span>
              </h1>
              <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                Gestiona tu restaurante con herramientas de última generación.
                Libro digital, CRM, eventos, lealtad y más.
                <span className="font-semibold text-orange-600 dark:text-orange-400"> 24 superpoderes con IA.</span>
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-4">
                <Button size="lg" variant="outline"
                  className="rounded-full px-8 h-14 text-lg gap-2 border-2 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 w-full sm:w-auto"
                  onClick={() => setShowVideo(true)}>
                  <Play className="h-5 w-5 text-orange-500" /> Ver Demo
                </Button>
                <a href="mailto:hola@okgo.mx">
                  <Button size="lg" className="rounded-full px-8 h-14 text-lg gap-2 bg-orange-500 hover:bg-orange-600 text-white shadow-xl shadow-orange-500/30 w-full sm:w-auto">
                    Contactar <ArrowRight className="h-5 w-5" />
                  </Button>
                </a>
              </div>
              <div className="pt-8 flex items-center justify-center lg:justify-start gap-8">
                <div className="text-center">
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">500+</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Restaurantes</p>
                </div>
                <div className="h-8 w-px bg-gray-200 dark:bg-gray-700" />
                <div className="text-center">
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">1M+</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Reservaciones</p>
                </div>
                <div className="h-8 w-px bg-gray-200 dark:bg-gray-700" />
                <div className="text-center">
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">4.9</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">Rating</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative z-10">
                <img
                  src="/assets/landing/hero_restaurant_v2.png"
                  alt="OkReserva Platform"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-orange-500 rounded-2xl rotate-12 opacity-20 dark:opacity-10" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-amber-500 rounded-2xl -rotate-12 opacity-20 dark:opacity-10" />
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
            <ChevronDown className="h-8 w-8 text-gray-400 dark:text-gray-600" />
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50 dark:bg-gray-900/50 border-y border-gray-100 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: '28', label: 'Superpoderes', icon: Zap },
              { value: '24/7', label: 'Bot con IA', icon: Mic },
              { value: '99.9%', label: 'Uptime', icon: ShieldCheck },
              { value: '< 1min', label: 'Setup', icon: Clock },
            ].map((stat, i) => {
              const StatIcon = stat.icon;
              return (
                <div key={i} className="space-y-2">
                  <div className="flex items-center justify-center gap-2">
                    <StatIcon className="h-6 w-6 text-orange-500" />
                    <span className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">{stat.value}</span>
                  </div>
                  <p className="text-gray-500 dark:text-gray-400">{stat.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Features Header */}
      <section className="pt-24 pb-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400 text-sm font-medium">
            <Globe className="h-4 w-4" />
            Herramientas de Última Generación
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 dark:text-white">
            Todo lo que tu restaurante necesita
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Desde el libro digital hasta portal de clientes con IA.
            Una suite completa de 28 herramientas profesionales.
          </p>
        </div>
      </section>

      {/* All Features */}
      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {features.map((feature, index) => (
            <FeatureSection key={feature.id} feature={feature} index={index} isDark={isDark} />
          ))}
        </div>
      </section>

      {/* Tech Section */}
      <section className="py-24 bg-gray-50 dark:bg-gray-900/50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 text-sm font-medium">
            <Zap className="h-4 w-4" />
            Tecnología de Punta
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
            Construido con lo mejor
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
            React, FastAPI, MongoDB y modelos de IA de última generación.
            Arquitectura moderna, escalable y segura para tu negocio.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
            {[
              { name: 'React', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
              { name: 'FastAPI', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
              { name: 'MongoDB', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' },
              { name: 'GPT-4', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
              { name: 'TailwindCSS', color: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400' },
              { name: 'WhatsApp API', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
            ].map((tech, i) => (
              <span key={i} className={cn("px-5 py-2 rounded-full font-medium text-sm", tech.color)}>
                {tech.name}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-500 via-orange-600 to-amber-500" />
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center text-white space-y-8">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            ¿Listo para transformar tu restaurante?
          </h2>
          <p className="text-lg sm:text-xl opacity-90 max-w-2xl mx-auto">
            Únete a más de 500 restaurantes que ya están usando OkReserva
            para ofrecer experiencias excepcionales a sus clientes.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a href="mailto:hola@okgo.mx">
              <Button size="lg" className="rounded-full px-10 h-14 text-lg font-semibold bg-white text-orange-600 hover:bg-gray-100 shadow-xl">
                Contactar Ventas
              </Button>
            </a>
            <a href="mailto:hola@okgo.mx">
              <Button size="lg" variant="outline"
                className="rounded-full px-10 h-14 text-lg font-semibold border-2 border-white/30 text-white hover:bg-white/10">
                Solicitar Demo
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 bg-white dark:bg-gray-950 border-t border-gray-100 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <img
                src={okReservaLogo}
                alt="OkReserva"
                className="h-8 mb-4"
                style={{ filter: isDark ? 'brightness(0) invert(1)' : 'none' }}
              />
              <p className="text-gray-500 dark:text-gray-400 max-w-sm">
                La plataforma de reservaciones más completa para restaurantes modernos en México y Latinoamérica.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Producto</h4>
              <ul className="space-y-2 text-gray-500 dark:text-gray-400">
                <li><a href="#" className="hover:text-orange-500 transition-colors">Funcionalidades</a></li>
                <li><a href="#" className="hover:text-orange-500 transition-colors">Integraciones</a></li>
                <li><Link to="/clientes" className="hover:text-orange-500 transition-colors">Portal Clientes</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Contacto</h4>
              <ul className="space-y-2 text-gray-500 dark:text-gray-400">
                <li><a href="mailto:hola@okgo.mx" className="hover:text-orange-500 transition-colors">hola@okgo.mx</a></li>
                <li><a href="mailto:hola@okgo.mx" className="hover:text-orange-500 transition-colors">Soporte</a></li>
                <li><a href="mailto:hola@okgo.mx" className="hover:text-orange-500 transition-colors">Solicitar Demo</a></li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-100 dark:border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              © 2026 OkReserva. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500 dark:text-gray-400">
              <Link to="/terminos" className="hover:text-orange-500 transition-colors">Términos</Link>
              <Link to="/privacidad" className="hover:text-orange-500 transition-colors">Privacidad</Link>
              <Link to="/aviso-legal" className="hover:text-orange-500 transition-colors">Aviso Legal</Link>
              <Link to="/cookies" className="hover:text-orange-500 transition-colors">Cookies</Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={() => setShowVideo(false)}>
          <div className="relative w-full max-w-4xl aspect-video bg-gray-900 rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}>
            <Button variant="ghost" size="icon"
              className="absolute top-4 right-4 z-10 text-white hover:bg-white/20 rounded-full"
              onClick={() => setShowVideo(false)}>
              <span className="text-2xl leading-none">×</span>
            </Button>
            <div className="w-full h-full flex items-center justify-center text-white">
              <div className="text-center space-y-4">
                <Play className="h-16 w-16 mx-auto text-orange-500" />
                <p className="text-lg">Video demo próximamente</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
